// @flow
import moment from 'moment';
import SunCalc from 'suncalc';

import range from 'lodash/range';

/**
 * The observer's position for calculating sunrise and sunset
 */
const OBSERVER_POSITION = [47, 19];

export function leftPad(s) {
  return s.toString().length < 2 ? `0${s}` : s;
}

export function formatMinutesAsTime(insertColon = false) {
  return minutes => {
    const mins = minutes < 0 ? 0 : minutes;
    const hours = Math.floor(mins / 60);

    return `${leftPad(hours)}${insertColon ? ':' : ''}${leftPad(
      mins - hours * 60
    )}`;
  };
}

export function computeTimeRangeSSC(minDate, maxDate) {
  const min = moment(minDate);
  const max = moment(maxDate || min);

  const times = range(0, max.diff(min, 'days') + 1).map(() =>
    SunCalc.getTimes(min.add(1, 'days'), ...OBSERVER_POSITION)
  );

  return {
    minSunrise: Math.min(
      ...times.map(
        t => t.sunrise.getUTCHours() * 60 + t.sunrise.getUTCMinutes()
      )
    ),
    maxSunset: Math.max(
      ...times.map(t => t.sunset.getUTCHours() * 60 + t.sunset.getUTCMinutes())
    ),
  };
}



// WEBPACK FOOTER //
// ./utils/datetime.js